module.exports = __webpack_public_path__ + "static/media/tip.7068643e.wav";